export default {
    title: 'Organization',
    subtitle: 'Organization details and information.',
    logo: {
        title: 'Logo',
        helper: 'Your organization logo, displayed across the platform.',
        hint: 'Square image, at least 256×256px recommended.',
    },
    general: {
        title: 'General',
        name: 'Name',
        slug: 'Slug',
        slugHint: 'URL-friendly identifier for your organization.',
    },
    language: {
        title: 'Language',
        subtitle: 'The selected language will be used for all emails sent on behalf of your organization.',
        label: 'Language',
    },
    branding: {
        title: 'Branding',
        primaryColor: 'Primary color',
        primaryColorHint: 'Accent color used across the platform.',
    },
    contact: {
        title: 'Contact',
        email: 'Email',
        phone: 'Phone',
        website: 'Website',
    },
    legal: {
        title: 'Legal information',
        // The invoiced identity left this page on 2026-09-20: it is held by the invoicing service
        // and is edited under Billing. What is left here are the organization's own two
        // descriptive mentions.
        legalName: 'Registered company name',
        taxId: 'Tax number',
    },
    system: {
        title: 'System',
        createdAt: 'Created',
    },
}
